module.exports = __webpack_public_path__ + "img/web_customers_say_03.8666f440.jpg";